<template>
  <div class="home-body">
    <div class="wrap-black banner-with-copy">
      <div class="row">
        <div class="col-xs-12 col-md-6 pic">
          <picture title="">
            <!--[if IE 9]><video style="display: none;"><![endif]-->
            <source srcset="/static/img/features/banner1_800.jpg" media="(min-width: 501px) and (max-width: 800px)">
            <source srcset="/static/img/features/banner1_800.jpg" media="(min-width: 801px) and (max-width: 1200px)">
            <source srcset="/static/img/features/banner1_800.jpg" media="(min-width: 1201px) and (max-width: 1600px)">
            <source srcset="/static/img/features/banner1_1000.jpg" media="(min-width: 1601px)">
            <!--[if IE 9]></video><![endif]-->
            <img src="/static/img/features/banner1_800.jpg" alt="">
          </picture>
          <div class="overlay"></div>
        </div>
        <div class="col-xs-12 col-md-6  banner-content-wrap">
          <div class="banner-copy">
            <h1>CLEX <br />Features</h1>
            <p>
              What really sets us apart is our most outstanding feature. CLEX starts users off with easier study content which progressively gets more challenging.
              This increased challenge uniquely matches the learning speed of each individual, maximizing their learning potential.
            </p>
            <a href="https://mailchi.mp/3bf25cf56493/signup-for-landing-page" class="btn-pub btn-pub-blank fixed-width xs-full-width">Sign Up for Free</a>
          </div>
        </div>
      </div>
    </div>

    <div class="features-row">
      <div class="container ptb-100">
        <div class="row feature xs-mb-50">
          <div class="col-xs-12 col-sm-6 pic text-center">
            <img src="/static/img/icons/features/Features_Icons-01.svg" alt="Use micro notes to help you focus on your studies" />
          </div>
          <div class="col-xs-12 col-sm-6 xs-pt-30">
            <h2>
              Micro notes
            </h2>
            <p class="large-text">Use micro notes to help you focus on your studies.</p>
          </div>
        </div>
        <div class="row feature">
          <div class="col-xs-12 col-sm-6 col-md-push-6 pic text-center">
            <img src="/static/img/icons/features/Features_Icons-02.svg" alt="Build word banks to help you improve your memorization skills" />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30">
            <h2>
              Word banks
            </h2>
            <p class="large-text">Build word banks to help you improve your memorization skills.</p>
          </div>

        </div>
        <div class="row text-center xs-mt-50">
          <div class="col">
            <video-player src="/static/video/demo.mp4" reference="homeVideo">
            </video-player>
          </div>
        </div>
        <div class="hidden-sm hidden-xs xs-pt-50">
          <HorizontalAd :containerClass="''"></HorizontalAd>
        </div>
      </div>
    </div>

    <div class="bg-slide text-center features-col">
      <div class="container ptb-100">
        <div class="row">
          <div class="col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic">
            <img src="/static/img/icons/features/Features_Icons-03.svg" alt="Challenge Yourself" />
            <h2>
              Challenge Yourself
            </h2>
            <p class="large-text">Set your own study challenge levels for <br />each lecture note.</p>
          </div>
          <div class="col-xs-12 col-md-6 pic">
            <img src="/static/img/icons/features/Features_Icons-04.svg" alt="Shared Learning" />
            <h2>
              Shared learning
            </h2>
            <p class="large-text">Share learning notes with your<br /> class mates.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="features-row">
      <div class="container ptb-100">
        <div class="row feature xs-mb-50">
          <div class="col-xs-12 col-sm-6 pic text-center">
            <img src="/static/img/icons/features/Features_Icons-05.svg" alt="Schedule Studying" />
          </div>
          <div class="col-xs-12 col-sm-6  xs-pt-30">
            <h2>
              Schedule Studying
            </h2>
            <p class="large-text">Set your own testing dates to match your study schedule.</p>
          </div>
        </div>
        <div class="row feature">
          <div class="col-xs-12 col-sm-6 col-md-push-6 pic text-center">
            <img src="/static/img/icons/features/Features_Icons-06.svg" alt="Study Anywhere" />
          </div>
          <div class="col-xs-12 col-sm-6 col-md-pull-6 xs-pt-30">
            <h2>
              Study Anywhere
            </h2>
            <p class="large-text">Test your knowledge at your own pace on any device at any time.</p>
          </div>
        </div>
        <div class="xs-pt-50">
          <HorizontalAd :containerClass="''"></HorizontalAd>
        </div>
      </div>
    </div>

    <div class="wrap-black text-center features-col">
      <div class="container">
        <div class="row">
          <div class="col-xs-12 col-md-6 xs-mb-50 md-mb-0 pic">
            <img src="/static/img/icons/features/Features_Icons-07.svg" alt="Secure Studying" />
            <h2>
              Secure Studying
            </h2>
            <p class="large-text">Create your own secure personal<br /> student account.</p>
          </div>
          <div class="col-xs-12 col-md-6 pic">
            <img src="/static/img/icons/features/Features_Icons-08.svg" alt="Cloud Storage" />
            <h2>
              Cloud Storage
            </h2>
            <p class="large-text">Store all your study notes in one<br /> secure location.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import _ from 'underscore'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
  import HorizontalAd from '../shared/ads/HorizontalAd'
  import VerticalAd from '../shared/ads/VerticalAd'
  import VideoPlayer from '../shared/media/VideoPlayer';

export default {
    components: {
      HorizontalAd,
      VerticalAd,
      VideoPlayer
  },
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .home-body { background: #FFFFFF; }
  

  .features-row {position:relative;overflow:hidden;}
  .features-row .container {max-width:700px;margin:0px auto;}
  .features-row .pic img {width:60%;}
  .features-row h2 {font-size:25px;margin:20px 0px 10px 0px;font-weight:600;}
  .features-row p {margin:0px;}
    .features-row .feature:nth-child(even) h2,
    .features-row .feature:nth-child(even) p { text-align: right; }

  .features-col {color:#FFFFFF;}
  .features-col .pic img {width:40%;}
  .features-col h2 {font-size:25px;margin:0px 0px 10px 0px;font-weight:600;}
  .features-col p {margin:0px;}

  .demo-btn { padding: 20px 40px; border-radius: 20px; font-size: 20px; font-weight: normal; }
  .demo-btn i {margin-right:20px;}

 

  .bg-slide { background: #4285f4; }
  .bg-slide .feature h2 { color: #FFFFFF;}
  .bg-slide .feature p { color: #FFFFFF;}

  @media only screen and (max-width:1100px) {
    .features-row .container {width:100%;padding-right:200px;}
  }
  @media only screen and (max-width:992px) {
    .features-row .container {padding-right: 15px;}
    
    .features-row .feature:nth-child(even) h2,
    .features-row .feature:nth-child(even) p { text-align: left; }  
  }
  @media only screen and (max-width:767px) {
    .features-row .pic img { width: 30%; }
    .features-row .feature {text-align:center;}
    .features-row .feature:nth-child(even) h2,
    .features-row .feature:nth-child(even) p { text-align: center; }
    .banner-with-copy p { font-size: 15px; line-height: 18px; margin: 20px 0px; }
    }
</style>



// WEBPACK FOOTER //
// FeaturesPage.vue?dfb07d3a